import React from 'react';

class HomeCarousel extends React.Component {
    render() {
        return (
            <div id="home-carousel" className="carousel slide col-12 col-md-7 col-lg-6" data-ride="carousel" data-interval="3000">
                <ol className="carousel-indicators">
                    <li data-target="#home-carousel" data-slide-to="0" className="active"/>
                    <li data-target="#home-carousel" data-slide-to="1"/>
                    <li data-target="#home-carousel" data-slide-to="2"/>
                </ol>
                <div className="carousel-inner dark-background home-carousel-image" role="listbox">
                    <div className="carousel-item active home-carousel-image" style={{backgroundImage: 'url(\'images/5.jpg\')'}}/>
                    <div className="carousel-item home-carousel-image" style={{backgroundImage: 'url(\'images/6.jpg\')'}}/>
                    <div className="carousel-item home-carousel-image" style={{backgroundImage: 'url(\'images/7.jpg\')'}}/>
                </div>
                <a className="carousel-control-prev" href="#home-carousel" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"/>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#home-carousel" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"/>
                    <span className="sr-only">Next</span>
                </a>
            </div>
        );
    }
}

export default HomeCarousel;